import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import classNames from 'classnames';

import { withLocales, withClientConfig } from '@spotahome/soyuz/client';

import { localesShape } from '@spotahome/soyuz/shapes';
import Metrics from '@spotahome/soyuz-metrics';

import { InstanceManager, EcommerceManagerFactory } from '@common/tracking';

import { bannerList } from '@common/components/HomeCardBanner/config';

import AdsQueryApiService from '../../../LEGACY/javascripts/cornucopia/ads/ads-query-api-service';

import HomeCard from '../Homecard';
import HomeCardBanner from '../HomeCardBanner';

import EmptyList from './EmptyList';
import NoResultsMessage from './NoResultsMessage';

import './HomeCardList.scss';

function scrollToCard(cardClicked) {
  if (cardClicked) {
    const scrollOffset =
      $('.search-filters').height() -
      $('.search-actions').height() +
      $('.search-context').height();

    $('.search-scroll').animate(
      {
        scrollTop: cardClicked.offsetTop + scrollOffset
      },
      1000
    );
  }
}

function hasNewMarkers(oldMarkers, newMarkers) {
  return (
    JSON.stringify(oldMarkers.map(e => e.id)) !==
    JSON.stringify(newMarkers.map(e => e.id))
  );
}

function indexCardsById(cards) {
  return cards
    .filter(card => card)
    .reduce(
      (acc, card) => ({
        ...acc,
        ...{
          [card.id]: card
        }
      }),
      {}
    );
}

async function getCardsFromIds(cardIds, locale) {
  let newCards = {};
  if (cardIds.length) {
    try {
      const res = await AdsQueryApiService.getHomecardsFromIds(cardIds, locale);

      if (res.data) {
        newCards = indexCardsById(res.data.homecards);
      }
    } catch (err) {
      console.error(err);
    }
  }

  return newCards;
}

function getCardIds(cards = []) {
  return cards
    .reduce((acc, marker) => [...acc, ...marker.rentableUnits], [])
    .map(card => ({
      id: card.id,
      coord: card.coord
    }));
}

function isHomecardSelected(currentCardId, clickedCards) {
  const { rentableUnitIds = [] } = clickedCards || {};
  return rentableUnitIds.includes(currentCardId);
}

const hasFilters = (filters = {}) =>
  !!Object.keys(filters).reduce(
    (acc, filterKey) => acc || filters[filterKey].length,
    false
  );

const freeCancellationCurrentlyShape = {
  freeCancellationCurrently: PropTypes.string
};

class HomeCardList extends PureComponent {
  static propTypes = {
    results: PropTypes.number.isRequired,
    totalResults: PropTypes.number.isRequired,
    markerList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    initialHomecards: PropTypes.shape({}),
    filters: PropTypes.shape({
      'move-in': PropTypes.string,
      'move-out': PropTypes.string,
      flexibleMoveOut: PropTypes.bool,
      flexibleMoveIn: PropTypes.bool
    }),
    onCardMouseEnter: PropTypes.func.isRequired,
    onCardMouseLeave: PropTypes.func.isRequired,
    clearExtendedFilters: PropTypes.func.isRequired,
    calculateMarkersWithoutBounds: PropTypes.func.isRequired,
    adMarkerClicked: PropTypes.shape({
      id: PropTypes.number
    }),
    locales: PropTypes.shape(localesShape).isRequired,
    currentPage: PropTypes.number.isRequired,
    hasMap: PropTypes.bool.isRequired,
    cityId: PropTypes.string.isRequired,
    cancellationPolicies: PropTypes.shape({
      flexible: PropTypes.shape(freeCancellationCurrentlyShape),
      standard: PropTypes.shape(freeCancellationCurrentlyShape),
      strict: PropTypes.shape(freeCancellationCurrentlyShape)
    }),
    pointOfInterest: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number
    }),
    hasLazyLoad: PropTypes.bool,
    clientConfig: PropTypes.shape({
      featureToggle: PropTypes.shape({
        showHomecardBanner: PropTypes.bool
      })
    }).isRequired
  };

  static defaultProps = {
    cancellationPolicies: {},
    filters: {},
    adMarkerClicked: {},
    initialHomecards: {},
    pointOfInterest: {},
    hasLazyLoad: false
  };

  state = {
    indexedCards: this.props.initialHomecards,
    cardList: getCardIds(this.props.markerList),
    cardsLoading: false
  };
  listElement = {
    firstChild: {}
  };

  componentDidMount() {
    const { indexedCards, cardList } = this.state;
    const clientTrackingInstance = InstanceManager.getClientSideInstance();
    this.ecommerceManager = EcommerceManagerFactory(clientTrackingInstance);
    this.trackProductImpressions(cardList, indexedCards);
  }

  componentWillReceiveProps = async nextProps => {
    if (this.props.adMarkerClicked !== nextProps.adMarkerClicked) {
      if (nextProps.adMarkerClicked && nextProps.adMarkerClicked.id) {
        const firstRentableUnit = nextProps.adMarkerClicked.id;
        scrollToCard(this[firstRentableUnit]);
      }
    }
    if (hasNewMarkers(this.props.markerList, nextProps.markerList)) {
      document.querySelector('.search-filters').scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

      this.setState({
        cardsLoading: true
      });

      const cardList = getCardIds(nextProps.markerList);
      const cardListIds = cardList.map(card => card.id);

      if (nextProps.markerList.length === 0 && !this.state.cardsLoading) {
        Metrics.ga.sendEvent('search-page', 'no-results-found');
      }

      $('#spinner-list-loader').show();
      let indexedCards;
      try {
        indexedCards = await getCardsFromIds(
          cardListIds,
          this.props.locales.current
        );

        this.setState({
          cardList,
          indexedCards,
          cardsLoading: false
        });
        this.trackProductImpressions(cardList, indexedCards);
      } catch (err) {
        console.error(err);
      }

      $('#spinner-list-loader').fadeOut();
    }
  };

  trackProductImpressions = (cardList, indexedHomecards) => {
    try {
      this.ecommerceManager.trackSearchPageImpressions(
        cardList,
        indexedHomecards,
        this.props.cityId
      );
    } catch (err) {
      console.error(err);
    }
  };

  trackCardPosition = (position, cardData) => () => {
    const { photoUrls, monthlyPrice } = cardData;
    const { cityId } = this.props;
    const track = [
      position,
      hasFilters(this.props.filters),
      this.props.hasMap,
      this.props.currentPage,
      this.state.cardList.length,
      cardData.id,
      photoUrls.homecard,
      monthlyPrice.minimumPrice,
      cardData.checked,
      cardData.type,
      cardData.isInstantBooking,
      cardData.isSuperlister,
      cardData.isSelect
    ].join(';');

    this.ecommerceManager.trackSearchPageHomecardClick(
      cardData,
      position,
      cityId
    );
    Metrics.ga.sendEventWithClientId('dwh-click-homecard-relevance', track, {
      nonInteraction: true
    });
  };

  hasCancellationPolicyData = cancellationType => {
    if (this.props.cancellationPolicies[cancellationType]) {
      return this.props.cancellationPolicies[cancellationType];
    }
    return false;
  };

  cardsContainFreeCancellation = cards =>
    Object.values(cards).some(card =>
      this.hasCancellationPolicyData(card.cancellationPolicy)
    );

  renderHomeCardBanner = position => {
    const { cityId, clientConfig } = this.props;
    const banner = bannerList(cityId)[position];
    if (
      clientConfig.featureToggle.showHomecardBanner &&
      banner &&
      banner.isActive
    ) {
      const bannerName = banner.name;

      return (
        <div
          className="l-list__item"
          ref={node => {
            this[bannerName] = node;
          }}
        >
          <HomeCardBanner
            bannerName={bannerName}
            isOneColumnView={
              this.listElement.clientWidth &&
              this.listElement.firstChild.clientWidth ===
                this.listElement.clientWidth
            }
          />
        </div>
      );
    }
    return null;
  };

  renderHomecardList = () => {
    const { cardList, indexedCards } = this.state;

    return cardList.map((card, position) => {
      const cardData = indexedCards[card.id];

      if (cardData) {
        return (
          <React.Fragment key={`homecard-${card.id}`}>
            {this.renderHomeCardBanner(position)}
            <div
              className="l-list__item"
              ref={node => {
                this[card.id] = node;
              }}
            >
              <HomeCard
                data={cardData}
                id={cardData.id}
                freeCancellationDeadline={this.hasCancellationPolicyData(
                  cardData.cancellationPolicy
                )}
                isFreeCancellationVariant
                noSecurityDeposit={cardData.noSecurityDeposit}
                isFavorite={cardData.isFavorite}
                moveIn={this.props.filters['move-in']}
                moveOut={this.props.filters['move-out']}
                flexibleMoveOut={this.props.filters.flexibleMoveOut}
                flexibleMoveIn={this.props.filters.flexibleMoveIn}
                onCardMouseEnter={this.props.onCardMouseEnter}
                onCardMouseLeave={this.props.onCardMouseLeave}
                onClick={this.trackCardPosition(position, cardData)}
                pointOfInterest={this.props.pointOfInterest}
                reviews={cardData.reviews}
                selected={isHomecardSelected(
                  card.id,
                  this.props.adMarkerClicked
                )}
                hasLazyLoad={this.props.hasLazyLoad}
              />
            </div>
          </React.Fragment>
        );
      }
      return null;
    });
  };

  renderContent() {
    const { indexedCards, cardsLoading } = this.state;
    const { markerList } = this.props;

    if (cardsLoading) {
      return <EmptyList />;
    }

    if (markerList && Object.keys(indexedCards).length) {
      return this.renderHomecardList();
    }

    return (
      <NoResultsMessage
        totalResults={this.props.totalResults}
        clearExtendedFilters={this.props.clearExtendedFilters}
        results={this.props.results}
        centerResultsInMap={this.props.calculateMarkersWithoutBounds}
      />
    );
  }

  render() {
    const classes = classNames({
      'l-list': true,
      'l-list--marker-selected': this.props.adMarkerClicked !== null
    });

    return (
      <div
        data-cy="property-list"
        className={classes}
        ref={elem => {
          this.listElement = elem;
        }}
      >
        {this.renderContent()}
      </div>
    );
  }
}

export default withClientConfig()(withLocales()(HomeCardList));
